import React from "react";

/* The Love Genome official mark (gold heart + DNA + tree) presented as a
   premium medallion on its native black, sized via className. */
export const Logo = ({ className = "" }) => (
  <span
    className={`relative inline-flex items-center justify-center overflow-hidden rounded-full bg-black ring-1 ring-gold/30 shadow-lg ${className}`}
    aria-hidden="true"
  >
    <img
      src="/brand/logo_emblem.png"
      alt="The Love Genome"
      className="w-full h-full object-cover scale-[1.06]"
      draggable="false"
    />
  </span>
);

export default Logo;
